import React from 'react';
import { Formik } from 'formik';
// @ts-ignore
import { Heading, Loader } from 'arag-ui-lib';
import SurveyForm from './surveyForm';
import generalStyle from '../../assets/styles/generalStyle.module.scss';
import codes from '../../utils/constants/codes';
import { useTranslation } from 'react-i18next';

type Props = {
    questions: any;
    onSubmitSurvey: (values: any) => void;
    posting: boolean;
    heading: string;
};
const SurveyFormWrapper = (props: Props) => {
    const { questions, onSubmitSurvey, posting, heading } = props;
    const { t } = useTranslation();
    if (questions && questions.questions?.length === 0) {
        return <Loader variant="inline" label={`${t('loading')}`} />;
    }
    return (
        <>
            <div className={generalStyle['content-heading']}>
                <Heading
                    variant="h3"
                    title={
                        `${heading && heading !== codes.surveyRejectedType ? heading : ''}` +
                        ' ' +
                        'Survey'
                    }
                />
            </div>
            <Formik
                initialValues={{}}
                onSubmit={(values, actions) => {
                    onSubmitSurvey(values);
                }}
            >
                {formikProps => {
                    return (
                        <SurveyForm
                            questions={questions}
                            formikProps={formikProps}
                            posting={posting}
                        />
                    );
                }}
            </Formik>
        </>
    );
};

export default SurveyFormWrapper;
